import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  href?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  href = '#pricing'
}: CTAButtonProps) {
  const isExternal = href.startsWith('http');
  const sharedClassName = `relative overflow-hidden group bg-brand-green text-white font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-3 w-full max-w-md mx-auto cursor-pointer no-underline ${className}`;
  const handleClick = (e?: React.MouseEvent) => {
    // Fire Meta Pixel AddToCart for checkout links
    if (isExternal && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'El Escudo Hormonal 40+',
        content_type: 'product',
        value: 27.0,
        currency: 'USD'
      });
    }
    onClick?.();
  };
  const innerContent = <>
      <span className="relative z-10 flex items-center gap-2" data-id="element-120">
        {children}
        <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-121" />
      </span>
      <div className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-122"></div>
      <div className="absolute inset-0 rounded-full border-2 border-brand-green animate-ping opacity-20" data-id="element-123"></div>
    </>;
  if (href) {
    return <motion.a href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={handleClick} className={sharedClassName} data-id="element-124">
        {innerContent}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={sharedClassName} data-id="element-125">
      {innerContent}
    </motion.button>;
}